'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by lyj on 2016/11/1.
                                          */

// import { push } from 'react-router-redux';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _groupBuyingOrderList = require('redux/modules/groupBuyingOrderList');

var groupBuyingOrderListActions = _interopRequireWildcard(_groupBuyingOrderList);

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

var _reactRouter = require('react-router');

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupBuyingOrderList = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var location = _ref.location;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('团购订单')));
    promises.push(dispatch(groupBuyingOrderListActions.load(location.query)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.groupBuyingOrderList.data
  };
}, (0, _extends3.default)({}, groupBuyingOrderListActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GroupBuyingOrderList, _Component);

  function GroupBuyingOrderList() {
    (0, _classCallCheck3.default)(this, GroupBuyingOrderList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GroupBuyingOrderList).call(this));

    _this.state = {
      orderItem: '',
      direction: '',
      filter: '',
      currentPage: 0
    };
    return _this;
  }

  (0, _createClass3.default)(GroupBuyingOrderList, [{
    key: 'onItemClick',
    value: function onItemClick(clickItem) {
      var load = this.props.load;

      var currentFilter = { orderStatus: clickItem };
      if (clickItem === '全部') {
        currentFilter = '';
      }
      this.setState({
        filter: currentFilter
      });
      if (load) {
        load(currentFilter, 0);
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch() {
      var load = this.props.load;
      var _state = this.state;
      var orderItem = _state.orderItem;
      var direction = _state.direction;
      var filter = _state.filter;

      var value = this.refs.searchInput.value;
      if (load) {
        var currentFilter = filter;
        if (value && value !== '') {
          currentFilter = (0, _extends3.default)({}, filter, { FindValue: value });
        } else {
          delete currentFilter.FindValue;
        }
        this.setState({
          filter: currentFilter
        });
        load(currentFilter, 0, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var load = this.props.load;
      var _state2 = this.state;
      var orderItem = _state2.orderItem;
      var direction = _state2.direction;
      var filter = _state2.filter;

      if (load) {
        this.setState({
          currentPage: page
        });
        load(filter, page, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      var filter = this.state.filter;

      var headArray = [{
        text: '全部',
        img: 'http://tupian.goeasy.cn:9999/yipinwang/orderlist/a3.png',
        order: '全部'
      }, {
        text: '团购中',
        img: 'http://tupian.goeasy.cn:9999/yipinwang/orderlist/a1.png',
        order: '团购中'
      }, {
        text: '团购成功',
        img: 'http://tupian.goeasy.cn:9999/yipinwang/orderlist/a2.png',
        order: '团购成功'
      }, {
        text: '已取消',
        img: 'http://tupian.goeasy.cn:9999/yipinwang/orderlist/a5.png',
        order: '已取消'
      }];
      var styles = require('./GroupBuyingOrderList.scss');
      var currentFilterText = '全部';
      if (filter) {
        currentFilterText = filter.orderStatus;
      }
      var orderListShow = '';
      var totalPageNumber = 1;
      if (data) {
        var orderList = data.orderList;
        var orderListError = data.orderListError;
        var orderListRecordCount = data.orderListRecordCount;
        var orderListPagesize = data.orderListPagesize;

        if (orderListError) {
          orderListShow = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.ErrorLabel, { error: 'orderListError: ' + orderListError })
          );
        } else {
          orderListShow = _react2.default.createElement(
            'div',
            { className: styles.jiesuannpage },
            orderList instanceof Array ? orderList.map(function (order, index) {
              return _react2.default.createElement(_components.GroupBuyingOrderListComponent, { key: index, index: index, order: order });
            }) : ''
          );
          totalPageNumber = parseInt(orderListRecordCount / orderListPagesize, 10);
          if (orderListRecordCount % orderListPagesize > 0) {
            ++totalPageNumber;
          }
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.orderlistcomponent },
        _react2.default.createElement(
          'div',
          { className: styles.danlie },
          _react2.default.createElement(
            'ul',
            { className: styles.danlieul },
            headArray.map(function (item, index) {
              return _react2.default.createElement(
                'li',
                { key: index, onClick: function onClick() {
                    _this2.onItemClick(item.order);
                  },
                  className: currentFilterText === item.text ? styles.active : '' },
                _react2.default.createElement(
                  'i',
                  null,
                  _react2.default.createElement('img', {
                    src: item.img,
                    alt: '' })
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  item.text
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.danlieshou },
            _react2.default.createElement('input', { type: 'text', ref: 'searchInput', className: styles.inp }),
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/dan1.png', alt: '',
              onClick: this.onSearch.bind(this) })
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement('div', { className: styles.linkb }),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.jiesuannpage },
            orderListShow
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/personalcenter/personalbuying/productpreselection', className: styles.danliebtn },
            '返回'
          )
        ),
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : '',
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return GroupBuyingOrderList;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  load: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = GroupBuyingOrderList;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/GroupBuyingOrderList/GroupBuyingOrderList.js
 ** module id = 1486
 ** module chunks = 0
 **/